import { FlatList, Image, Keyboard, Modal, Pressable, StyleSheet, Text, TextInput, TouchableOpacity, View } from "react-native"
import BaseScreen from "./BaseScreen";
import { color_333333, color_BEBEBE, color_main, ColorLine, white } from "../assets/style/colors";
import { ImageView } from "../components/ImageView";
import { useCallback, useState } from "react";
import { CountryCode, countryCode } from "../country";
import i18n, { getLanguage } from "../language/i18n";
import { Str_Search, Str_SelectCountryRegion } from "../language/string_res";
import { MainNavProps } from "./navigation/main/MainParamList";
import { useAppNavigation } from "./navigation";
import { AuthNavProps } from "./navigation/auth/AuthParamList";

const itemHeight = 55;
let searchTimer: any = null
// CountryCodeManager.ts
type CountryCodeCallback = (code: string) => void;

class CountryCodeManager {
    private callback?: CountryCodeCallback;

    // 注册监听（覆盖之前的监听）
    setListener(callback: CountryCodeCallback) {
        this.callback = callback;
    }

    // 移除监听
    removeListener() {
        this.callback = undefined;
    }

    // 触发事件
    select(code: string) {
        this.callback && this.callback(code);
    }
}

// 导出单例
export const countryCodeManager = new CountryCodeManager();

export const AuthCountryCodeSelete = ({}: AuthNavProps<'AuthCountryCodeSelete'>) => {
    return (<CountryCodeSelete />)
}

export const MainCountryCodeSelete = ({}: MainNavProps<'MainCountryCodeSelete'>) => {
    return (<CountryCodeSelete />)
}
const CountryCodeSelete = () => {
    const [searchText, setSearchText] = useState('')
    const [data, setData] = useState(countryCode)
    const navigation = useAppNavigation()

    const onChangeText = (text: string) => {
        if (searchTimer) {
            clearTimeout(searchTimer);
        }
        setSearchText(text)
        searchTimer = setTimeout(() => {
            if (text.length > 0) {
                setData(countryCode.filter(v => v.code.includes(text)))
            } else {
                setData(countryCode)
            }
        }, 300);
    }
    const itemClick = (item: CountryCode,) => {
        countryCodeManager.select(item.code)
        navigation.goBack()
    }
    const renderItem = useCallback(({ item, index }: { item: CountryCode, index: number }) => {

        const code = getLanguage()
        let name = item.name.zh
        if (code === 'es') {
            name = item.name.es
        } else if (code === 'ja') {
            name = item.name.ja
        } else if (code === 'vi') {
            name = item.name.vi
        } else if (code === 'pt') {
            name = item.name.pt
        } else if (code === 'en') {
            name = item.name.en
        }
        return (<Pressable
            onPress={() => { itemClick(item) }}
            style={{ height: itemHeight, backgroundColor: white, justifyContent: 'center', paddingHorizontal: 20 }}>
            <Text style={{ color: color_333333, fontSize: 16 }}>{item.icon} {name} ({item.code})</Text>
            <View style={{ backgroundColor: ColorLine, start: 20, end: 20, height: 1, position: 'absolute', bottom: 0 }} />
        </Pressable>)
    }, [])
    return (
        <BaseScreen>
            <View style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: 'center',
                height: 44, backgroundColor: white
            }}>
                <ImageView
                    activeOpacity={1}
                    onClick={() => { navigation.goBack() }}
                    source={require('../assets/image/icon_close.png')}
                    imgStyle={{ width: 26, height: 26 }}
                    style={{
                        paddingHorizontal: 20,
                        height: 44,
                        position: 'absolute',
                        start: 0,
                        justifyContent: 'center',
                        alignItems: 'center'
                    }} />
                <Text
                    style={{
                        fontSize: 18,
                        fontWeight: "bold",
                        fontFamily: '',
                        color: "black",
                    }} >{Str_SelectCountryRegion}</Text>
            </View>
            <View style={styles.searchContainer}>
                <View style={styles.search}>
                    <Image source={require("../assets/image/icon_search.png")} style={{ width: 20, height: 20, objectFit: "contain" }} />
                    <TextInput
                        style={styles.inputTarget}
                        selectionColor={color_main}
                        placeholderTextColor={color_BEBEBE}
                        value={searchText}
                        inputMode={'numeric'}
                        onChangeText={onChangeText}
                        placeholder={Str_Search} />
                    {searchText && searchText.length > 0 && <ImageView
                        onClick={() => {
                            onChangeText("");
                            Keyboard.dismiss;
                        }}
                        source={require("../assets/image/icon_del.png")} />}
                </View>
            </View>
            <FlatList
                style={{ flex: 1 }}
                data={data}
                keyExtractor={item => `${item.code}-${item.name.zh}`}
                getItemLayout={(data, index) => ({
                    length: itemHeight,
                    offset: itemHeight * index,
                    index,
                })}
                renderItem={renderItem} />
        </BaseScreen>
    )
}

const styles = StyleSheet.create({
    searchContainer: {
        flexDirection: "row",
        paddingVertical: 10,
        alignItems: "center",
        backgroundColor: "#f6f6f6"
    },
    search: {
        borderRadius: 5,
        flex: 1,
        height: 46,
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 12,
        marginHorizontal: 12,
        backgroundColor: white
    },
    inputTarget: {
        flex: 1, marginStart: 10, color: color_333333,
    },


})